import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { useFormErrorMessageHandler } from '@/utils/form';
import { ref, PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { required } from '@vuelidate/validators';
import { ElAlert, ElNotification } from 'element-plus';

import {
  NkStack,
  NkGroup,
  NkForm,
  NkFormItem,
  NkInputText,
  NkButton,
} from '@/core/components';

import { useForm } from '@/core/hooks/forms';
import { useFormDelete } from '@/hooks/forms';
import {
  useGetDeviceGroupQuery,
  useDeleteDeviceGroupMutation,
} from '@/entities/device-group/hooks';

import { DeviceGroup } from '@/entities/device-group/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceGroupDelete',
  props: {
  id: {
    type: Number as PropType<DeviceGroup['id']>,
    required: true,
  },
},
  emits: ['submitted'],
  setup(__props, { emit }) {

const props = __props



const { t } = useI18n();
const router = useRouter();

const form = ref();


const { onSubmitted } = useForm(emit);

const queryData = computed(() => ({ id: props.id, }));

const {
  query: { data },
  mutation: {
    mutateAsync,
    isError,
    error: deleteDeviceGroupError,
    isLoading
  },
  fields,
  rules,
  canDelete,
} = useFormDelete({
  queryData,
  mutationHook: useDeleteDeviceGroupMutation,
  queryHook: useGetDeviceGroupQuery,
  fields: {
    name: '',
  },
  rules: {
    name: required,
  },
  canDeleteValuePath: 'name',
});

const { error } = useFormErrorMessageHandler(deleteDeviceGroupError);

const description = computed(() => `"${ data.value?.name }"`);

const submit = () => {
  form.value.validator.$validate().then((valid: boolean) => {
    if (valid && !isLoading.value) {
      mutateAsync({
        id: props.id,
      }, {
        onSuccess: () =>
          ElNotification({
            title: t('device_group.notification.delete.title'),
            message: t('device_group.notification.delete.message'),
            type: 'success',
            position: 'bottom-right',
          }),
      }).then((res) => {
        onSubmitted(res);
        router.back();
      });
    }
  });
};


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkStack), null, {
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createBlock(_unref(ElAlert), {
            key: 0,
            title: _unref(error),
            type: "error"
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkForm), {
        ref_key: "form",
        ref: form,
        fields: _unref(fields),
        rules: _unref(rules)
      }, {
        footer: _withCtx(() => [
          _createVNode(_unref(NkGroup), { position: "right" }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
                type: "danger",
                disabled: !_unref(canDelete),
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.delete')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])), [
                [_directive_loading, _unref(isLoading)]
              ])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(ElAlert), {
            title: _ctx.$t('forms.delete.warning'),
            description: _unref(description),
            type: "error",
            closable: false,
            effect: "dark"
          }, null, 8, ["title", "description"]),
          _createVNode(_unref(NkFormItem), {
            label: _ctx.$t('forms.delete.typeToContinue'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkInputText), {
                modelValue: _unref(fields).name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(fields).name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["fields", "rules"])
    ]),
    _: 1
  })), [
    [_directive_loading, _unref(isLoading)]
  ])
}
}

})